// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__FGiyI","Cards-wrapper":"Cards_Cards-wrapper__CDMbu","card":"Cards_card__FYjWO","icon-wrapper":"Cards_icon-wrapper__qhpI5"};